import React from 'react';
import { SitemapItems } from '../../../../types';
import * as S from './styles';

type Props = Pick<SitemapItems, 'path' | 'title'> & { onClick?: () => void };

const SitemapItem = ({ path, title, onClick }: Props) => {
  return (
    <S.SitemapItem>
      <S.SitemapLink to={path} onClick={() => onClick?.()}>
        {title}
      </S.SitemapLink>
    </S.SitemapItem>
  );
};

export default SitemapItem;
